export default __webpack_public_path__ + "static/media/charm-s2.ea12685b.png";